import * as React from 'react'
import { IntlProvider } from 'react-intl'
import {
  Action,
  async,
  AsyncState,
  loadingAsyncState,
  nothing,
  stateful,
  Unit,
  unloadedAsyncState,
  Widget
} from 'widgets-for-react'
import { LoaderCircle } from '../../../accommodations/models/loading'
import { getPaymentStatus, PaymentStatusResponse } from '../../../api/payments'
import { waitingForStatusLoading } from '../../../widgets/payments'

export type PaymentStatusProps = {
  booking_id: string
  payment_id: string
}

export type PaymentStatusState = {
  status: AsyncState<PaymentStatusResponse>
  setFlashMessage: AsyncState<Unit>
  pollCount: number
}

export default (props: PaymentStatusProps): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <div className="page-section page-section--pt page-section--payment-methods-loading">
      <div className="grid-container grid-container--small">
        <div className="grid-100">
          {stateful<PaymentStatusState>()(s0 =>
            waitingForStatusLoading(props, s0).map(a => a(s0))
          )({
            status: loadingAsyncState(_ => getPaymentStatus(props.payment_id)),
            setFlashMessage: unloadedAsyncState(),
            pollCount: 0
          }).run(_ => {})}
          <header className="page-section__head">
            <h1 className="h2">
              {I18n.t('payments.payment_loader.checking_payment')}
            </h1>
          </header>

          <LoaderCircle />

          <div className="page-section__visual" />

          <p className="h4 page-section__text">
            {I18n.t('payments.payment_loader.checking_payment_questions')}
          </p>
        </div>
      </div>
    </div>
  </IntlProvider>
)
